import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NavCollapseService {
  private isMinimized = new Subject<boolean>();

  constructor() { }

  isMinimized$ = this.isMinimized.asObservable();

  updateIsMinimized(value: boolean) {
    this.isMinimized.next(value);
  }
}
